

















import { store } from '@/store';
import { Component, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
  get gc() {
    return store.galaxyCruise
  }

  get level() {
    return this.gc.quest.level
  }

  get levelName() {
    return (this.level as any)[`${this.$i18n.locale}_name`]
  }

  get tractIndex() {
    if (store.galaxyCruise.series !== 'infinite') {
      const i = this.level.tract_ids_for_user!.indexOf(this.gc.quest.tract_id)
      return i
    }
    else {
      return this.level.tract_ids_for_user!.length - 1
    }
  }

  get nRemainingTracts() {
    const n = this.level.num_tracts
    return n - this.tractIndex - 1
  }
}
